import React from 'react'
import Navbar from './Navbar'

export default function Wrapper( { children } ) {
  return (
    <>
      <div className="h-full bg-gray-200">
          <Navbar />
          <div className="md:ml-[250px] lg:ml-[250px] bg-[#F6F6F6] h-full">
              {children}
          </div>
      </div>
    </>
  )
}
